<ion-toolbar class="main-header-toolbar">
    <app-student-header></app-student-header>
</ion-toolbar>

<ion-content [fullscreen]="true" class="content">
    <!--refresher-->
    <ion-refresher class="ion-hide-sm-up" slot="fixed" [pullFactor]="0.5" [pullMin]="100"
                   (ionRefresh)="refresh($event)">
        <ion-refresher-content></ion-refresher-content>

    </ion-refresher>
    <!--refresher end-->

    <ion-grid fixed class="page-grid no-margin-top student-grid student-page">

        <div class="shadow" *ngIf="this.educationalMaterial">
            <app-semi-header [title]="'materialComp.allMaterial'|transloco" [showProgress]="true"
                             [avgProgress]="this.educationalMaterial.textbook.avgProgress"
                             [info]="this.educationalMaterial.info"
            ></app-semi-header>
        </div>


        <ion-row class="study-content ion-no-padding">
            <ion-col size="12" class="ion-no-margin ion-no-padding white-col">

                <div class="materials-wrapper ion-no-margin ion-no-padding" *ngIf="this.educationalMaterial">

                    <div class="block" *ngFor="let unit of this.educationalMaterial.textbook.book"
                         [ngClass]="{'past': unit.isPassed}"
                         (click)=" unit.link ? openUrl(unit.link , unit.showProgress, unit.title) : null">

                        <div class="info">
                            <div class="img-container" *ngIf="unit.showProgress">
                                <div class="progress-wrapper-circle"
                                     *ngIf="unit.isPassed || !unit.isPassed && unit.progress != 0">

                                    <div class="progress-number">
                                        {{ unit.progress }}%
                                    </div>

                                    <round-progress class="progress"
                                                    [current]="unit.progress"
                                                    [max]="100"
                                                    [stroke]="25"
                                                    [rounded]="true"
                                                    [color]="'#83B25F'"
                                                    [background]="'white'"
                                                    [duration]="800"
                                                    [animation]="'easeInOutQuart'"
                                                    [animationDelay]="0"
                                    />


                                </div>


                                <div class="progress-wrapper-circle" *ngIf="!unit.isPassed && unit.progress == 0">

                                    <round-progress class="progress"
                                                    [max]="100"
                                                    [rounded]="true"
                                                    [stroke]="25"
                                                    [background]="'#CFCFCF'"
                                                    [duration]="800"
                                                    [animation]="'easeInOutQuart'"
                                                    [animationDelay]="0"
                                    />


                                </div>

                            </div>


                            <div class="img-container" *ngIf="!unit.showProgress">
                                <img src="assets/images/student/lesson_white.png" alt="lesson">
                            </div>


                            <div class="title">{{ unit.title }}</div>
                        </div>


                        <div class="action">

                            <div class="details " [ngClass]="{'d-none': !unit?.hasFeedback}" >
                                <img src="assets/images/icons/feedback.svg" alt="feedback">

                                <div class="details-popover d-none">
                                    <div class="info">
                                        {{ ('textbook.leaveFeedback' | transloco) }}
                                    </div>
                                </div>

                            </div>


                            <div class="arrow">

                                <svg width="32" height="32" viewBox="0 0 24 24" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M8.51192 19.5694C8.19743 19.2999 8.161 18.8264 8.43057 18.5119L14.0122 12L8.43057 5.4881C8.161 5.1736 8.19743 4.70013 8.51192 4.43056C8.82641 4.16099 9.29989 4.19741 9.56946 4.51191L15.5695 11.5119C15.8102 11.7928 15.8102 12.2072 15.5695 12.4881L9.56946 19.4881C9.29989 19.8026 8.82641 19.839 8.51192 19.5694Z"
                                          fill="#3F403F"/>
                                </svg>

                            </div>

                        </div>


                    </div>

                </div>


            </ion-col>


            <ion-col size="12" class="ion-no-margin ion-no-padding">

                <app-banners [banners]=""></app-banners>
            </ion-col>


        </ion-row>


    </ion-grid>

    <app-footer></app-footer>

</ion-content>
<app-chats></app-chats>
